import { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Campaign } from 'domains/campaigns/types';
import ABTestInsightsModal from './AbTestInsightsModal/ABTestInsightsModal';
import { formatDateTime } from 'domains/core/components/DateRangeText/DateRangeText';
import { themeColors, brandColors } from 'colors';

type WinnerSentStatusProps = {
    campaign: Campaign;
};

const WinnerSentStatus = ({ campaign }: WinnerSentStatusProps) => {
    const [isInsightsModalOpen, setIsInsightsModalOpen] = useState(false);

    const handleViewInsights = () => {
        setIsInsightsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsInsightsModalOpen(false);
    };

    // Get the winner send info from campaign
    const winnerSend = campaign.sends?.find((send) => send.id === campaign.abTestConfig?.winnerSendId);
    const winnerName = winnerSend?.name || 'New Content';
    // Get the scheduled timestamp from the 3rd send (index 2) in the sends array
    const sentTime = campaign.sends?.[2]?.scheduledTimestamp;

    return (
        <>
            <ABTestInsightsModal campaign={campaign} isOpen={isInsightsModalOpen} handleModalClose={handleModalClose} />
            <Box
                sx={{
                    backgroundColor: brandColors.lightMint,
                    borderRadius: '8px',
                    padding: '16px',
                }}
            >
                <Stack spacing={1}>
                    <Stack spacing={0.5}>
                        <Stack direction="row" alignItems="baseline" spacing={1.4}>
                            <Box
                                sx={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: themeColors.success.main,
                                }}
                            />
                            <Typography>winner sent</Typography>
                        </Stack>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            '{winnerName}' sent on {sentTime ? formatDateTime(sentTime) : 'Unknown'}
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} justifyContent={'end'} sx={{ paddingLeft: '20px' }}>
                        <Button
                            variant="outlined"
                            onClick={handleViewInsights}
                            sx={{
                                backgroundColor: 'white',
                            }}
                        >
                            View Insights
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default WinnerSentStatus;
